import React from 'react';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { progressLine as ProgressLine } from 'ui/views/generic/progressLine';
 *
 * // render
 * <ProgressLine propName='propValue'/>
 */
export const progressLine = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-progress-line', props.className );

    return (
        <div className={ widgetClassName }>
            <div className='ui-progress-line__line' />
        </div>
    );
};

// set display name
progressLine.displayName = 'progressLine';

// set default props
progressLine.defaultProps = {};

// prop types
progressLine.propTypes = {};
